var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.31 3.498c.2-.33 1.3-1.534 2.086-1.497.235.02.442.161.61.326.388.378 1.497 1.808 1.56 2.11.152.737-1.502 1.486-1.233 2.23.687 1.679 2.32 3.314 4 4 .744.269 1.493-1.386 2.23-1.232.301.062 1.732 1.17 2.11 1.558.164.168.307.376.326.611.03.827-1.248 1.943-1.497 2.086-.588.42-1.355.413-2.29-.021-2.607-1.085-6.776-5.175-7.88-7.882-.424-.93-.453-1.7-.022-2.289",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;